import { useState } from "react";
import { useNavigate, NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { Menu as MaterialMenu } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { logo } from "../../assets";

import "./index.css";

import HamburgerButton from "./HamburgerButton";
import Menu from "./Menu";
import { GetStartedButton } from "../index";

import LanguageSwitcher from "../LanguageSwitcher";

const Navbar = () => {
  const { t: translation } = useTranslation();
  const navigate = useNavigate();
  const [toggleMenu, setToggleMenu] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggleMenu = () => {
    setToggleMenu(!toggleMenu);
  };

  const navigateToHomepage = () => {
    navigate("/");
  };

  return (
    <nav className="navbar">
      <img
        className="navbar__logo"
        src={logo}
        alt="logo"
        onClick={navigateToHomepage}
        tabIndex="1"
      />

      <ul>
        <li>
          <NavLink to="/">{translation("navbar.homeNavLinK")}</NavLink>
        </li>

        {/* <li>
          <a id="productsButton" href="https://store.netifyhub.com/">
            <p>{translation("navbar.productsNavLinK")}</p>
          </a>
        </li> */}

        {/* <li>
          <NavLink to="/pricing">
            {translation("navbar.pricingNavLinK")}
          </NavLink>
        </li> */}

        <li>
          <NavLink to="/about">{translation("navbar.companyNavLinK")}</NavLink>
        </li>

        <li>
          <Button
            id="companyButton"
            aria-controls={open ? "companyMenu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            sx={{
              padding: 0,
              fontWeight: 400,
            }}
          >
            <p>{translation("navbar.supportNavLinK")}</p>

            <KeyboardArrowDownIcon />
          </Button>

          <MaterialMenu
            id="companyMenu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "companyButton",
            }}
          >
            <MenuItem onClick={handleClose}>
              <NavLink to="/contact">
                {translation("navbar.contactNavLinK")}
              </NavLink>
            </MenuItem>

            <MenuItem onClick={handleClose}>
              <NavLink to="/compatibility">
                {translation("navbar.compatibilityNavLinK")}
              </NavLink>
            </MenuItem>

            <MenuItem onClick={handleClose}>
              <NavLink to="/frequently-asked-questions">
                {translation("navbar.faqsNavLinK")}
              </NavLink>
            </MenuItem>

            <MenuItem onClick={handleClose}>
              <Link to="/#how-it-works">
                {translation("navbar.howItWorksNavLinK")}
              </Link>
            </MenuItem>
          </MaterialMenu>
        </li>

        <li>
          <LanguageSwitcher
            sx={{
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                padding: 0,
              },
              "& fieldset": {
                border: "unset",
              },
            }}
          />
        </li>
      </ul>

      <div className="display-desktop">
        <div className="signIn-div">
          <NavLink className="loginButton" to="/login">
            {translation("navbar.singInNavLinK")}
          </NavLink>

          <GetStartedButton
            arrowColor={"#00614B"}
            arrowDivColor={"white"}
            background={"#00614B"}
            titleColor={"white"}
            onClick={() => navigate("/register")}
            style={{ padding: "0 8px" }}
            title={translation("navbar.getStartedNavLinK")}
          />
        </div>
      </div>

      <Stack direction="row" alignItems="center" gap={2} useFlexGap>
        <div className="display-mobile">
          <Button
            sx={{
              fontSize: "12px",
              textTransform: "initial",
              padding: "8px",
            }}
            target="_blank"
            href="https://store.netifyhub.com/"
          >
            {translation("getYourCard")}
          </Button>
        </div>

        <HamburgerButton handleHamburgerButton={handleToggleMenu} />
      </Stack>

      {toggleMenu && <Menu handleToggleMenu={handleToggleMenu} />}
    </nav>
  );
};

export default Navbar;
